// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3K3VS","row":"styles_row__2HY4s"};